import { InputNumber } from 'antd';
import { DadosDepreciacao } from '@/features/laudo/types/laudo-wizard.types';
import { formatarPorcentagem } from '../utils';
import * as styles from '../styles';
import type { DadosCalculados } from '../types';

export const createColumns = (
  dados: DadosDepreciacao[],
  dadosCalculados: DadosCalculados[],
  handleInputChange: (index: number, field: keyof DadosDepreciacao, value: number | string) => void,
  disabled?: boolean,
  displayIdMap?: Record<string, string>
) => [
  {
    title: 'Identificação',
    dataIndex: 'identificacao',
    key: 'identificacao',
    width: 120,
    fixed: 'left' as const,
    render: (text: string) => {
      const label = displayIdMap?.[text] || text;
      return <strong style={{ color: text === 'Avaliando' ? '#1890ff' : '#000' }}>{label}</strong>;
    },
  },
  {
    title: 'Tipo',
    dataIndex: 'tipoImovel',
    key: 'tipoImovel',
    width: 120,
    render: (value: string) => <div style={styles.cellCenterStyle}>{value}</div>,
  },
  {
    title: 'Idade Aparente (anos)',
    dataIndex: 'idadeAparente',
    key: 'idadeAparente',
    width: 180,
    render: (value: number) => (
      <div style={styles.cellReadonlyStyle} title="Campo automático - vem dos Dados do Imóvel ou das Amostras">
        {value} anos
      </div>
    ),
  },
  {
    title: 'Estado de Conservação',
    dataIndex: 'estadoConservacao',
    key: 'estadoConservacao',
    width: 220,
    render: (value: string) => (
      <div style={styles.cellReadonlyStyle} title="Campo automático - vem dos Dados do Imóvel ou das Amostras">
        {value}
      </div>
    ),
  },
  {
    title: 'Vida Útil (anos)',
    dataIndex: 'vidaUtil',
    key: 'vidaUtil',
    width: 150,
    render: (value: number, record: DadosDepreciacao) => {
      const indexOriginal = dados.findIndex((d) => d.identificacao === record.identificacao);
      return (
        <InputNumber
          value={value}
          onChange={(newValue) => handleInputChange(indexOriginal, 'vidaUtil', Number(newValue) || 0)}
          style={{ width: '100%' }}
          step={1}
          precision={0}
          addonAfter="anos"
          disabled={disabled ?? false}
        />
      );
    },
  },
  {
    title: '% da VU',
    dataIndex: 'porcentagemVU',
    key: 'porcentagemVU',
    width: 120,
    render: (_: any, record: DadosDepreciacao) => {
      return <div style={styles.cellCenterStyle}>{formatarPorcentagem(record.porcentagemVU)}</div>;
    },
  },
  {
    title: 'Coef. Heidecke',
    dataIndex: 'coefHeidecke',
    key: 'coefHeidecke',
    width: 140,
    render: (_: any, record: DadosDepreciacao) => {
      return <div style={styles.cellCenterStyle}>{record.coefHeidecke.toFixed(4)}</div>;
    },
  },
  {
    title: 'Valor Residual',
    dataIndex: 'valorResidual',
    key: 'valorResidual',
    width: 150,
    render: (value: number, record: DadosDepreciacao) => {
      const indexOriginal = dados.findIndex((d) => d.identificacao === record.identificacao);
      return (
        <InputNumber
          value={value ?? 0.2}
          onChange={(newValue) => handleInputChange(indexOriginal, 'valorResidual', Number(newValue) ?? 0.2)}
          style={{ width: '100%' }}
          step={0.05}
          min={0}
          max={1}
          precision={2}
          disabled={disabled ?? false}
        />
      );
    },
  },
  {
    title: 'Depreciação',
    dataIndex: 'depreciacao',
    key: 'depreciacao',
    width: 140,
    render: (_: any, record: DadosDepreciacao) => {
      return <div style={styles.cellHighlightStyle}>{record.depreciacao.toFixed(3)}</div>;
    },
  },
];
